import styled from 'styled-components';

export const InsightsHomeWrapper = styled.div`
 display: flex;
 width: 100%;
 flex-direction: column;
`;
export const InsightsHomeWrapperContent = styled.div`
flex: 1;
`;